import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {config} from "../config";

export const IndexPageNavigation = () => {

    const breadcrumbs = [
            {
                title: config.titles.plural,
            }
        ].map((item, index) => (
            <Box key={index}>{item.title}</Box>
        ));
    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};

